RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const Model = Backbone.Model.extend({
        defaults: {
            type: 'info',
            closeable: true,
            title: null,
            description: null
        }
    });

    widgets.TokenRequestWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        processProps: function (props) {
            return _.defaults(props, {
                companyId: props.company_id
            });
        },

        haveUserToken: function () {
            const me = this;
            return _.includes(me.getAuthedUserIds(), RivalIQ.state.user.get('id'));
        },

        accountHitMaxTokensLimit: function () {
            const me = this;

            const totalAccountTokens = _.get(me.curation, 'totalTokensInAccount');
            const maxTokens = RivalIQ.state.account.get('plan')[`${me.getProp('channel')}_max_tokens`];

            return totalAccountTokens >= maxTokens;
        },

        getAuthedUserIds: function () {
            const me = this;

            return _.get(me.curation, ['sources', me.getProp('source'), 'userIds'], []);
        }
    });

    const AdditionalAuthorizationView = RivalIQ.channels.views.ChannelWall.mixin({
        size: 'additional',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        className: `panel panel-default ${RivalIQ.channels.views.ChannelWall.prototype.className}`,

        initialize: function () {
            const me = this;

            me.options = _.extend(me.options || {}, {
                source: me.getProp('source'),
                companyId: me.getProp('companyId'),
                userIds: me.dashboardModel.getAuthedUserIds(),
                model: new Model(me.getProps())
            });
        }
    });

    const AdditionalAuthorizationWidget = widgets.AdditionalAuthorizationWidget = widgets.TokenRequestWidget.extend({
        filter: function () {
            const me = this;

            if (me.isDismissed()) {
                return true;
            }

            const userHasToken = me.haveUserToken();
            const source = me.getProp('source');
            if (RivalIQ.enums.sourceDetails[source].multiOauthToken) {
                return userHasToken || me.accountHitMaxTokensLimit();
            }

            return userHasToken;
        },

        panelView: AdditionalAuthorizationView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.ADDITIONAL_AUTHORIZATION, AdditionalAuthorizationWidget);

}, window.s);
